
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import './dialogboxrewiew.css';

const DialogBoxRewiew = ({ isOpen, onClose }) => {
  const [nameValue, setNameValue] = useState('');
  const [rating, setRating] = useState(1);
  const [hoveredRating, setHoveredRating] = useState(0);

  const [favoriteText, setFavoriteText] = useState('');
  const [commentText, setCommentText] = useState('');

  if (!isOpen) return null;

  const handleStarClick = (index) => {
    if (rating === index) {
      setRating(0);
    } else {
      setRating(index);
    }
  };

  const handleStarMouseEnter = (index) => {
    setHoveredRating(index);
  };

  const handleStarMouseLeave = () => {
    setHoveredRating(rating);
  };

  const handleSubmit = () => {
    if (!nameValue.trim()) {
      toast.error('Имя — обязательное поле', {
        style: {
          border: '1px solid #000',
          padding: '16px',
          color: '#000',
        },
        iconTheme: {
          primary: '#000',
          secondary: '#FFFAEE',
        },
      });
      return;
    }

    
    setNameValue('');
    setRating(0);
    setHoveredRating(0);
    setFavoriteText('');
    setCommentText('');

    
    onClose();

    
    toast.success('Отзыв отправлен на модерацию', {
      style: {
        border: '1px solid #000',
        padding: '16px',
        color: '#000',
      },
      iconTheme: {
        primary: '#000',
        secondary: '#FFFAEE',
      },
    });
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-container">
        <button className="dialog-close-button" onClick={onClose}>
          &times;
        </button>

        <h2 className="dialog-title">Оставить отзыв</h2>
        <div className="dialog-divider" />

        <input
          className="dialog-input"
          type="text"
          placeholder="Ваше имя *"
          value={nameValue}
          onChange={(e) => setNameValue(e.target.value)}
        />

        <div className="rating-container">
          <span className="rating-text">Оценка</span>
          <div className="stars">
            {[1, 2, 3, 4, 5].map((starIndex) => {
              const isStarSelected = starIndex <= (hoveredRating || rating);
              return (
                <span
                  key={starIndex}
                  className={`star ${isStarSelected ? 'selected' : ''}`}
                  onClick={() => handleStarClick(starIndex)}
                  onMouseEnter={() => handleStarMouseEnter(starIndex)}
                  onMouseLeave={handleStarMouseLeave}
                >
                  ★
                </span>
              );
            })}
          </div>
        </div>

        <textarea
          className="dialog-textarea"
          placeholder="Больше всего понравилось"
          rows="4"
          value={favoriteText}
          onChange={(e) => setFavoriteText(e.target.value)}
        />

        <textarea
          className="dialog-textarea-comment"
          placeholder="Комментарий"
          rows="4"
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
        />

        <button className="dialog-submit-button" onClick={handleSubmit}>
          Оставить отзыв
        </button>
      </div>
    </div>
  );
};

export default DialogBoxRewiew;
